import { useLocation } from 'react-router-dom';

/**
 * Musteri-facing rotalar (QR menu, login) - kafenin abonelik/durum bilgisinden
 * tamamen bagimsiz olmasi gereken rotalar. Admin bildirim/kilit ekranlari
 * bu rotalarda ASLA gosterilmemeli.
 */
export function useIsPublicRoute(): boolean {
  const location = useLocation();
  return location.pathname.startsWith('/m/') || location.pathname === '/login';
}
